import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

export default function Home({ lang }: Props) {
  const { t } = useTranslation('home');
  const prefix = `/${lang}`;

  return (
    <Layout lang={lang}>
      <div className="jumbotron p-4 p-md-5 text-white rounded bg-dark">
        <div className="row">
          <div className="col-xl-6 col-md-6 px-0">
            <h1 className="display-5 font-italic">{t('greeting')}</h1>
            <div style={{ padding: '10px' }}>
              <p className="lead my-3">{t('intro')}</p>
              <p className="lead mb-0" style={{ borderRadius: '5px', backgroundColor: '#FFFFFF', margin: '0 auto', textAlign: 'center' }}>
                <Link to={`${prefix}/search`} className="text-white font-weight-bold">
                  <span style={{ color: '#000000', textDecorationLine: 'underline' }}>
                    {t('searchLink')}
                  </span>
                </Link>
              </p>
            </div>
          </div>
          <div className="col-xl-6 col-md-6 px-0">
            <img
              style={{ maxWidth: '100%' }}
              src="https://63900.selcdn.ru/iv/portfolio/my.jpg"
              className="img-responsive img-rounded center-block"
              alt={t('photoAlt')}
            />
          </div>
        </div>
      </div>

      <div className="row mb-2">
        <div className="col-md-6">
          <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
            <div className="col p-4 d-flex flex-column position-static">
              <strong className="d-inline-block mb-2 text-primary">{t('about.category')}</strong>
              <h3 className="mb-0">{t('about.title')}</h3>
              <p className="card-text mb-auto">{t('about.text')}</p>
              <Link to={`${prefix}/about`} className="stretched-link">{t('about.link')}</Link>
            </div>
            <div className="col-auto d-none d-lg-block">
              <img src="https://63900.selcdn.ru/iv/portfolio/about_for_list.png" alt={t('about.category')} />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
            <div className="col p-4 d-flex flex-column position-static">
              <strong className="d-inline-block mb-2 text-success">{t('experience.category')}</strong>
              <h3 className="mb-0">{t('experience.title')}</h3>
              <p className="mb-auto">{t('experience.text')}</p>
              <Link to={`${prefix}/experience`} className="stretched-link">{t('experience.link')}</Link>
            </div>
            <div className="col-auto d-none d-lg-block">
              <img src="https://63900.selcdn.ru/iv/portfolio/experiense_list.png" alt={t('experience.category')} />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
            <div className="col p-4 d-flex flex-column position-static">
              <strong className="d-inline-block mb-2 text-primary">{t('projects.category')}</strong>
              <h3 className="mb-0">{t('projects.title')}</h3>
              <p className="card-text mb-auto">{t('projects.text')}</p>
              <Link to={`${prefix}/projects`} className="stretched-link">{t('projects.link')}</Link>
            </div>
            <div className="col-auto d-none d-lg-block">
              <img src="https://63900.selcdn.ru/iv/portfolio/projects_list.png" alt={t('projects.category')} />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
            <div className="col p-4 d-flex flex-column position-static">
              <strong className="d-inline-block mb-2 text-success">{t('technology.category')}</strong>
              <h3 className="mb-0">{t('technology.title')}</h3>
              <p className="mb-auto">{t('technology.text')}</p>
              <Link to={`${prefix}/technology`} className="stretched-link">{t('technology.link')}</Link>
            </div>
            <div className="col-auto d-none d-lg-block">
              <img src="https://63900.selcdn.ru/iv/portfolio/technology_list.png" alt={t('technology.category')} />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
            <div className="col p-4 d-flex flex-column position-static">
              <strong className="d-inline-block mb-2 text-primary">{t('interest.category')}</strong>
              <h3 className="mb-0">{t('interest.title')}</h3>
              <p className="card-text mb-auto">{t('interest.text')}</p>
              <Link to={`${prefix}/interest`} className="stretched-link">{t('interest.link')}</Link>
            </div>
            <div className="col-auto d-none d-lg-block">
              <img src="https://63900.selcdn.ru/iv/portfolio/interest_list.png" alt={t('interest.category')} />
            </div>
          </div>
        </div>

        <div className="col-md-6">
          <div className="row no-gutters border rounded overflow-hidden flex-md-row mb-4 shadow-sm h-md-250 position-relative">
            <div className="col p-4 d-flex flex-column position-static">
              <strong className="d-inline-block mb-2 text-success">{t('hobby.category')}</strong>
              <h3 className="mb-0">{t('hobby.title')}</h3>
              <p className="mb-auto">{t('hobby.text')}</p>
              <Link to={`${prefix}/hobby`} className="stretched-link">{t('hobby.link')}</Link>
            </div>
            <div className="col-auto d-none d-lg-block">
              <img src="https://63900.selcdn.ru/iv/portfolio/hobby_list.png" alt={t('hobby.category')} />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
